import React, { useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Mic, Square, Loader2 } from 'lucide-react';

export const useSpeaker = () => {
  const { api } = useAuth();
  const audio = useRef(null);
  const speak = async (text, force) => {
    if (!force && audio.current && !audio.current.paused) { audio.current.pause(); return; }
    try {
      const r = await api.post('/voice-ai/tts', { text: text.slice(0, 4000) }, { responseType: 'blob' });
      audio.current?.pause();
      audio.current = new Audio(URL.createObjectURL(r.data));
      await audio.current.play();
    } catch { toast.error('No se pudo reproducir la voz'); }
  };
  speak.stop = () => audio.current?.pause();
  return speak;
};

export const MicButton = ({ onText, testid = 'mic-btn', disabled, className = '' }) => {
  const { api } = useAuth();
  const [state, setState] = useState('idle');
  const rec = useRef(null);

  const start = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const chunks = [];
      const mr = new MediaRecorder(stream);
      mr.ondataavailable = (e) => e.data.size && chunks.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState('busy');
        try {
          const fd = new FormData();
          fd.append('file', new Blob(chunks, { type: 'audio/webm' }), 'dictado.webm');
          const r = await api.post('/voice-ai/transcribe', fd);
          if (r.data.text) onText(r.data.text); else toast.error('No se detectó voz');
        } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo transcribir'); } finally { setState('idle'); }
      };
      rec.current = mr;
      mr.start();
      setState('rec');
    } catch { toast.error('Permite el acceso al micrófono para dictar'); }
  };
  const stop = () => rec.current?.state === 'recording' && rec.current.stop();

  return (
    <button type="button" data-testid={testid} disabled={disabled || state === 'busy'} onClick={state === 'rec' ? stop : start}
      aria-label={state === 'rec' ? 'Detener dictado' : 'Dictar por voz'} title={state === 'rec' ? 'Detener dictado' : 'Dictar por voz'}
      className={`rounded-lg px-3 py-2 disabled:opacity-40 ${state === 'rec' ? 'bg-red-600 text-white animate-pulse' : 'border border-slate-600 text-slate-300'} ${className}`}>
      {state === 'busy' ? <Loader2 className="w-4 h-4 animate-spin" /> : state === 'rec' ? <Square className="w-4 h-4" /> : <Mic className="w-4 h-4" />}
    </button>
  );
};
